// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4541":"8b827f39","8491":"bd6f0dd8"}[chunkId] + ".chunk.css";
};